<template>  
  <div class="container-fluid padding-15 sm-padding-10 split-container">
    <div class="row full-height">
      <div class="panel m-t-45 no-padding m-b-5">
        <div class="col-md-6">
          <h3 class="no-margin p-t-10 p-b-10">Organizations</h3>
        </div>
        <div class="clearfix"></div>
      </div>

      <div class="panel full-height">
        <div class="col-md-3 no-padding no-margin full-height">
          <OrganizationList ref="list" v-on:selected="onSelected">
          </OrganizationList>
        </div>
        <div class="col-md-9 no-padding no-margin panel full-height">
          <Organization ref="detail" :organization="selected" v-on:reload="onReload">
          </Organization>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import $ from 'jquery';
import _ from 'lodash';
import Organization from './Organization.vue';
import OrganizationList from './OrganizationList.vue';

export default {
  components: { OrganizationList, Organization },
  name: 'Organizations',
  props: {
    account: {
      type: Object,
      default: () => ({})
    },
    limit: {
      type: Number,
      default: 100
    }
  },
  data: () => ({
    organizations: [],
    selected: {}
  }),
  created() {
    window.loco = this;
  },
  mounted() {
  },
  methods: {    
    onSelected(organization) {
      this.selected = organization;
    },
    onReload(organization) {
      this.$refs.list.fetch();
    }
  }
}
</script>

<style scoped>
  .table.table-condensed thead tr th, .table.table-condensed tbody tr td, .table.table-condensed tbody tr td *:not(.dropdown-default) {
    font-size: 12px;
  }

  .table.table-condensed thead tr th.fs-18, .table.table-condensed tbody tr td.fs-18, .table.table-condensed tbody tr td.fs-18 *:not(.dropdown-default) {
    font-size: 18px;
  }

  .font-montserrat.small {
    font-size: 12px;
  }

  .split-container {
    height: calc(100% - 100px);
  }

</style>



// WEBPACK FOOTER //
// Organizations.vue?2c732e60